export const ReviseMeta = (title, keywords, description) => {
  const head = document.getElementsByTagName("head");

  // 修改 <title> 标签内容
  if (title) {
    document.title = title;
  }

  // 创建并修改 <meta> 标签
  const meta = document.createElement("meta");
  if (keywords) {
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", keywords);
  }
  if (description) {
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", description);
  }
  head[0].appendChild(meta);
};

// export const shareMeta = (url, title, image, description) => {
//     const head = document.getElementsByTagName("head");

//     // 创建并修改 <meta> 标签
//     const meta = document.createElement("meta");
//     if (title) {
//         document.querySelector('meta[property="og:title"]').setAttribute("content", title);
//     }
//     if (url) {
//         document.querySelector('meta[property="og:url"]').setAttribute("content", url);
//     }
//     if (image) {
//         document.querySelector('meta[property="og:image"]').setAttribute("content", image);
//     }
//     if (description) {
//         document.querySelector('meta[property="og:description"]').setAttribute("content", description);
//     }
//     head[0].appendChild(meta);
// }

export const shareMeta = (url, title, image, description) => {
  const metaTitle = document.querySelector('meta[property="og:title"]');
  const metaUrl = document.querySelector('meta[property="og:url"]');
  const metaImage = document.querySelector('meta[property="og:image"]');
  const metaDescription = document.querySelector(
    'meta[property="og:description"]'
  );

  // 如果找到对应的 meta 标签，则设置其内容
  if (metaTitle && title) {
    metaTitle.setAttribute("content", title);
  }
  if (metaUrl && url) {
    metaUrl.setAttribute("content", url);
  }
  if (metaImage && image) {
    metaImage.setAttribute("content", image);
  }
  if (metaDescription && description) {
    metaDescription.setAttribute("content", description);
  }
};
